// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.renter.RentalManagerRenterWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  RentalManagerRenterAddOrUpdateRentersRequestDto,
  RentalManagerRenterAddOrUpdateRentersResponseDto,
  RentalManagerRenterUpdateRenterRequestDto,
  RentalManagerRenterUpdateRenterResponseDto,
} from '../..';

export const RentalManagerRenterWebApiHandler_addOrUpdate_Path = '/api/web/v1/users/renter/addOrUpdate';

/**
 * Add or update renters and their roles
 */
export const RentalManagerRenterWebApiHandler_addOrUpdate = (
  postData: RentalManagerRenterAddOrUpdateRentersRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    never,
    RentalManagerRenterAddOrUpdateRentersRequestDto,
    RentalManagerRenterAddOrUpdateRentersResponseDto
  >(
    {
      endpoint: RentalManagerRenterWebApiHandler_addOrUpdate_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerRenterWebApiHandler_update_Path = '/api/web/v1/users/renter/update';

/**
 * Update renter
 */
export const RentalManagerRenterWebApiHandler_update = (
  postData: RentalManagerRenterUpdateRenterRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    never,
    RentalManagerRenterUpdateRenterRequestDto,
    RentalManagerRenterUpdateRenterResponseDto
  >(
    {
      endpoint: RentalManagerRenterWebApiHandler_update_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};
